
export enum HardmanActivityTypes {
    LogisticOperator = "LogisticOperator",
    Carrier = "Carrier",
    Producer = "Producer",
    Other = "Other"
};